//#region Util Imports

import * as moment from 'moment'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'

//#endregion

import { Enums } from '../../../models/common/enums'
import { IUserSession } from '../../../helpers/user-session'
import { Activity } from '../../../models/common/activity'
import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { ActionModel } from '../../api/api.models'
import { EventsNames } from '../../../helpers/events-names'
import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { i18n } from '../../common/i18n/common.i18n'
import { Details, DetailsScope, DetailsAccordion, DetailsAccordionSection } from '../../common/common.details'
import { CommonHelper } from '../../../helpers/common-helper'
import { Permissions } from '../../../helpers/permissions'
import { ConnectedObject } from '../../common/connected-object/connected-object.directive'
import { DetailsPopupOptions } from '../../common/details-popup/details-popup.directive'
import { GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { InfoPopupSource } from '../../common/info-popup/info-popup.directive'
import { HistorySource } from '../../common/history/history.directive.controller'
import { TemplateHelper, ConfigHelper, LocalizationHelper } from '../../../helpers'

interface CommonData {
    details: any
}

interface ActionsDetailsScope extends DetailsScope {
    id: number
    editId: number

    infoPopupSource: InfoPopupSource
    needInfoPopup: boolean

    common: CommonData

    connectedObject: ConnectedObject
    detailedParamGridOptions: GridOptions

    deviceAnswerGridOptions: GridOptions
    deviceAnswerGridInstance: DevExpress.ui.dxDataGrid

    deviceAnswerDetailCellPrepared(options)

    actionHistoryOptions: HistorySource
}

export class ActionsDetailsDirectiveController extends Details<ActionsDetailsScope> {
    private actionId: number
    private permissions: any[]
    private referenceId: number

    constructor($scope: ActionsDetailsScope, $q: ng.IQService, $timeout: ng.ITimeoutService, private api: Api, logger: LoggerService,
        localDictionary: LocalDictionaryFactory, protected userSession: IUserSession, protected referenceType: Enums.ReferenceType) {
        super($scope, $timeout, $q, logger, localDictionary, OperatorLayoutSettings.DevicePopupTabActive, userSession, referenceType)

        var actions: DevExpress.ui.dxButtonOptions[] = []

        $scope.infoPopupSource = {
            infoText: i18n('Popup', 'ConfigurationConsistent'),
            popupTitle: i18n('Popup', 'ConfigurationConsistencyCheck')
        }

        $scope.options = <DetailsPopupOptions>{
            title: i18n('Popup', 'ActionDetails'),
            openEventName: EventsNames.OPEN_ACTION_DETAILS_POPUP,
            closeEventName: EventsNames.CLOSE_ACTION_DETAILS_POPUP,
            delHasPermissions: 'false',
            id: $scope.id,
            getAccordionDataMethod: () => { return this.getAccordionData() },
            getAccordionSelectionMethod: () => { return this.getAccordionSelection() },
            updateAccordionMethod: (names: any[]) => { return this.updateAccordions(names) },

            actions: actions
        }

        $scope.deviceAnswerDetailCellPrepared = (options) => {
            if (options.rowType == "data") {
                var fieldData: string = options.value,
                    fieldHtml = "",
                    fieldColumnName = options.column.caption;

                //CUSTOM CELL FOR STATUS
                if (fieldData && fieldColumnName == i18n("Common", "Status")) {
                    if (fieldData.toUpperCase() == "OK") {
                        options.cellElement.css('background-color', '#02E6A1');
                    } else {
                        options.cellElement.css('background-color', '#F7484E');
                    }
                    fieldHtml += "<span>" +
                        fieldData +
                        "  </span>";
                    options.cellElement.html(fieldHtml);
                }
            }
        }

        this.accordionsNameToShow = 'common'

        $scope.popupFor = CommonHelper.action
        $scope.editId = $scope.$id
        $scope.common = <CommonData>{}

        $scope.connectedObject = {
            connectedObjectTitle: i18n('Common', 'CurrentAction'),
            connectedObjectName: "",
            connectedObjectVisibility: false,
            connectedObjectId: 0,
            connectedObjectMethod: 'action'
        }

        jQuery.when.apply(jQuery,
            [Permissions.ACTION_PARAMETERS, Permissions.ACTION_HISTORY, Permissions.ACTION_EDIT, Permissions.ACTION_PARAMETERS_NOT_READONLY, Permissions.ACTION_PACKETS, Permissions.PACKET_LIST]
                .map(p => Permissions.hasPermissions([p]))
        ).then((...permissions) => {
            this.permissions = permissions
            this.configureTabs(this.getTabs())
        })

        // popup open
        $scope.$on(EventsNames.OPEN_ACTION_DETAILS_POPUP + $scope.id, (event: ng.IAngularEvent, ...args: any[]) => {
            this.loadData(args[0], args[1])
        })
        // close
        $scope.$on(EventsNames.CLOSE_ACTION_DETAILS_POPUP + $scope.id, () => {
            this.hidePopup()
        })
    }

    loadData(id: number, objects: any[]) {
        this.resetData()

        this.$scope.modelId = id
        this.$scope.itemObjects = objects

        this.showPopup()

        var actionPromise = this.api.actions.getAction(this.$scope.modelId, this.$scope.requestsStates.getAction).then(actioneResult => {
            this.$scope.showTabs = true
            this.actionId = actioneResult ? actioneResult.id : null;
            this.referenceId = actioneResult.referenceId

            Permissions.hasPermissions([Permissions.PACKET_LIST]).then(hasPermission => {
                if (hasPermission) {
                    this.api.actions.getPackets(this.$scope.modelId).then(packets => {
                        this.updatePacketsData(packets)
                    })
                }
            })

            this.updateData(actioneResult)
            this.setHistoryOptions()

            this.$scope.popupTitle = actioneResult.name
        }).catch(reason => {
            this.logger.log(reason)
            this.$scope.showTabs = true
        })

    }

    resetData() {
        this.$scope.popupTitle = ''
        this.$scope.showTabs = false
        this.$scope.requestsStates.getAction = {}

        this.$scope.common.details = null
        this.$scope.detailedParamGridOptions = null
        this.$scope.deviceAnswerGridOptions = null
    }

    updateData(result: ActionModel) {
        this.$scope.detailedParamGridOptions = null

        this.localDictionary.getActionDisplayFields(result.referenceId ? result.referenceId : null).then(displayFields => {
            this.$scope.common.details = result ? Details.filterFields(result.fields, displayFields, result.detailsFields) : []
            var items = []
            result.detailsFields.forEach((field) => {
                var desc = ''
                var filteredFields = displayFields.filter(f => f.id == field.idDataType)
                if (filteredFields.length > 1) desc = filteredFields[0].caption
                else {
                    desc = this.localDictionary.getCaptionByIdDataType(field.idDataType)
                    if (desc == null) {
                        desc = field.caption
                    }
                }

                items.push({
                    description: desc,
                    index: field.index,
                    value: field.value,
                    typeId: field.typeId
                })
            })


            Permissions
                .hasPermissions([Permissions.ACTION_MODULE_ACTION_PARAMETERS_GRID_COLUMN_REORDER_DISALLOWED])
                .then(columnsReorderingDisabled => {
                    this.$scope.detailedParamGridOptions = {

                        name: "ActionDetails",
                        type: GridTypes.NO_SEARCH_BAR_SMALL,
                        buttonsOptions: {
                            enabled: false,
                        },
                        addCustomFilters: true,
                        localStorageVarForSavedEntity: "actionSavedParamGrid",
                        dictionariesForSave: displayFields,
                        allowColumnReordering: !columnsReorderingDisabled,
                        columns: [
                            {
                                dataField: "description",
                                caption: i18n("Common", "Description")
                            },
                            {
                                dataField: "index",
                                caption: i18n("Common", "Index")
                            },
                            {
                                dataField: "value",
                                caption: i18n("Common", "Value"),
                                dataType: "string",
                                calculateDisplayValue: (rowData) => {
                                    return CommonHelper.cellFormatForDifferentValues(rowData, null, null)
                                }
                            }
                        ],
                        dataSource: new DataSource(items)
                    }
                })
        })
    }

    updatePacketsData(packets: any) {
        this.$scope.deviceAnswerGridOptions = null
        this.$timeout(() => {
            if (packets.result) {
                packets.result.forEach((res, i) => {
                    // make raw uniqe
                    res.uniq = i
                    // DATE DORMAT
                    res.packetData.forEach(pd => {
                        pd.time = moment(pd.time).format(window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS'))
                    })
                    //DATA TYPES FROM DICTIONARY
                    var idDataTypes = res.packetData.map(dat => { return dat.dataType })
                    var dataTypes
                    this.localDictionary.getDataTypes(idDataTypes).then(dts => {
                        dataTypes = dts
                        res.packetData.forEach(pd => {
                            if (dataTypes) {
                                dataTypes.forEach(dt => {
                                    if (dt.id == pd.dataType) {
                                        pd.dataType = dt.name
                                        return
                                    }
                                })
                            }
                        })
                    })
                })

                this.localDictionary.getActionDevicesAnswerColumns().then(columns => {
                    Permissions.hasPermissions([Permissions.ACTION_MODULE_ACTION_PACKETS_GRID_COLUMN_REORDER_DISALLOWED]).then(columnsReorderingDisabled => {
                        this.$scope.deviceAnswerGridOptions = {
                            customValueToCaption: [
                                {
                                    columnName: "direction",
                                    values: [
                                        { value: 1, caption: i18n("Common", "Incoming") },
                                        { value: 2, caption: i18n("Common", "Outgoing") }
                                    ]
                                }
                            ],
                            name: "ActionDetails",
                            type: GridTypes.NO_SEARCH_BAR_SMALL,
                            allowColumnReordering: !columnsReorderingDisabled,
                            buttonsOptions: {
                                enabled: false,
                            },
                            onInitialized: e => {
                                this.$scope.deviceAnswerGridInstance = e.component
                            },

                            onEditorPreparing: function (e) {
                                if (e.parentType === "filterRow" && e.dataField == "direction") {
                                    e.editorOptions.displayExpr = function (data) {
                                        if (data === null)
                                            return i18n('Common', 'All')
                                        else
                                            if (data.id === 1)
                                                return i18n("Common", "Incoming")
                                            else
                                                return i18n("Common", "Outgoing")
                                    }
                                }
                            },

                            onCellPrepared: function (options) {
                                var fieldData = options.value,
                                    fieldHtml = "",
                                    fieldColumnName = options.column.caption;

                                if (options.rowType == "data") {

                                    //CUSTOM CELL FOR STATUS
                                    if (fieldData && fieldColumnName == i18n("Common", "Status")) {
                                        if (fieldData == "Delivered") {
                                            options.cellElement.css('background-color', '#02E6A1');
                                        } else {
                                            options.cellElement.css('background-color', '#F7484E');
                                        }
                                        fieldHtml += "<span>" +
                                            fieldData +
                                            "  </span>";
                                        options.cellElement.html(fieldHtml);
                                    }
                                    //CUSTOM CELL FOR DIRECTION
                                    if (fieldColumnName == i18n("Common", "Direction")) {
                                        if (fieldData == 1) {
                                            options.cellElement.css('color', '#02E6A1');
                                        }
                                        if (fieldData == 2) {
                                            options.cellElement.css('color', '#F7484E');
                                        }
                                    }
                                }
                            },
                            columnsDictionary: columns,
                            dataSource: new DataSource(packets.result),
                            masterDetail: {
                                enabled: true,
                                template: "detail"
                            }
                        }
                    })
                })
            }
        })
    }

    getTabs() {
        var [ACTION_PARAMETERS, ACTION_HISTORY] = this.permissions

        var tabs = []

        tabs.push({
            template:
                TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common), ConfigHelper.Icon.HOME, this.userSession),
            name: 'common'
        })
        if (ACTION_HISTORY) {
            tabs.push({
                template:
                    TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.History), ConfigHelper.Icon.HISTORY, this.userSession),
                name: 'history'
            })
        }

        return tabs
    }

    getAccordions() {
        var [ACTION_PARAMETERS, ACTION_HISTORY, ACTION_EDIT, ACTION_PARAMETERS_NOT_READONLY, ACTION_PACKETS, PACKET_LIST] = this.permissions

        var accordions: DetailsAccordion[] = []

        if (ACTION_PARAMETERS) {
            var items: DetailsAccordionSection[] = []

            items.push({
                title: i18n("Common", "ActionData"),
                canEdit: ACTION_EDIT && ACTION_PARAMETERS_NOT_READONLY,
                name: 'params',
                showStatus: false,
                editMethod: () => {
                    if (ACTION_EDIT && ACTION_PARAMETERS_NOT_READONLY) {
                        //implemennt
                    }
                },
                visible: true
            })
            items.push({
                title: i18n('Common', 'ActionParams'),
                canEdit: false,
                name: 'additional',
                showStatus: false,
                visible: true
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.ActionDetailsAccordions, 0, items))
        }

        if (ACTION_PACKETS || PACKET_LIST) {
            items = []
            items.push({
                title: i18n('Common', 'ActionDeviceAnswer'),
                canEdit: false,
                name: 'packets',
                showStatus: false,
                visible: true
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.ActionDetailsPackets, 1, items))
        }

        return accordions
    }

    // Options

    private setHistoryOptions(): void {
        this.$scope.actionHistoryOptions = {
            dataMethodName: null, // DO USUNIĘCIA
            id: null, // DO USUNIĘCIA
            name: 'actionsHistory',
            referenceType: this.referenceType,
            referenceValue: this.$scope.modelId,

            allowColumnReordering: !this.userSession
                .getLoggedOperator()
                .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.ActionHistory),
        }
    }

    // Options End
}